/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { push } from "connected-react-router";

import { dispatch } from "../../../store";
import { DataProvider } from "../../DataProvider";
import { IPaymentProvider } from "../IPaymentProvider";
import { ICheckoutRequestModel, IConfirmPaymentRequestModel } from "../models";

export class CryptoCoinPaymentProvider implements IPaymentProvider {
  async init(): Promise<void> {
    return Promise.resolve();
  }

  async checkout(data: ICheckoutRequestModel): Promise<void> {
    dispatch(
      push(
        `/buy-confirmation?mediaId=${data.MediaId}&priceId=${data.PriceId}&paymentId=${data.SessionId}`,
      ),
    );
    return Promise.reject("Not implemented");
  }

  async confirm(data: IConfirmPaymentRequestModel): Promise<void> {
    DataProvider.confirmPayment(data);
    if (data.Action === "CANCEL") {
      dispatch(push("/"));
    }
    return Promise.resolve();
  }
}
